import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import ResetPassword from '../../features/auth/components/ResetPassword';

const ResetPasswordRoute = () => {
  return (
    <ProtectedRoute requiresAuth={false}>
      <ResetPassword />
    </ProtectedRoute>
  );
};

export default ResetPasswordRoute;
